import React, { Component } from 'react'
import { MultiSelect } from 'react-selectize'
import { shallowEqual } from 'services/utils'
import styles from './styles'
import generalStyles, { overwrites } from 'controls/DropDown/styles'
import classNames from 'classnames'

export default class InputTag extends Component {
  constructor(props) {
    super(props)
    this.state = { tags: props.tags, isInputActive: false }
  }

  static defaultProps = {
    style: {}
  }

  setValue = (reduxValue, onChange) => selectValue => {
    this.setState({ tags: selectValue })
    if (!shallowEqual(selectValue, reduxValue)) {
      onChange(selectValue)
    }
  }

  createFromSearch = (options, values, search) => {
    let labels = values.map(value => value.label)
    if (search.trim().length == 0 || labels.indexOf(search.trim()) != -1) {
      return null
    }
    return { label: search.trim(), value: search.trim() }
  }

  render() {
    const {
      input: { value, onChange, onFocus, onBlur, ...restInput },
      placeholder,
      meta: { touched, error, warning },
      ...rest
    } = this.props

    const { isInputActive } = this.state

    return (
      <div
        className={classNames('input-tag', {
          'show-mini-placeholder': isInputActive,
          'show-error': error
        })}
        style={{ width: '100%', position: 'relative', ...this.props.style }}
      >
        {error ? (
          <span className="mini-placeholder mailbox-error">{error}</span>
        ) : (
          <span className="mini-placeholder">{placeholder}</span>
        )}
        <MultiSelect
          onFocus={() => {
            onFocus() // event is only preventDefault(), he doesn't have a target.
            this.setState({ isInputActive: true })
          }}
          meta={{ touched: true, error, warning }}
          values={this.state.tags}
          delimiters={[188]}
          theme="bootstrap3"
          createFromSearch={this.createFromSearch}
          onValuesChange={this.setValue(value, onChange)}
          renderNoResultsFound={() => null}
          {...restInput}
          {...rest}
        />
        <style jsx global>
          {generalStyles}
        </style>
        <style jsx global>
          {overwrites}
        </style>
        <style jsx>{styles}</style>
      </div>
    )
  }
}
